import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-mensajeticket',
  templateUrl: './mensajeticket.component.html',
  styleUrls: ['./mensajeticket.component.css']
})
export class MensajeticketComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<MensajeticketComponent>,
  ) { }

  ngOnInit() {
  }


  cerrarventana() {
    console.log ('entre a procedimienot cerrrar evntaba');
    this.dialogRef.close();
  }

}
